import React from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import TurkeyImage from '../assets/Turkey.jpg'; // Make sure to replace with the correct path to your image
const Turkey = () => {
  return (
    <Box
      id="turkey-section"
      component="section"
      sx={{
        color: 'white',
        borderRadius: 2,
        p: 4,
        mb: 10, // Added padding
      }}
    >
      <Container>
        <Grid
          container
          alignItems="center"
          direction={{ xs: 'column-reverse', md: 'row' }}
        >
          <Grid
            item
            xs={12}
            md={4}
            lg={6}
            sx={{
              my: 'auto',
              py: 6,
              pr: { xs: 3, lg: 2 },
              pl: { xs: 3, lg: 0 },
            }}
          >
            <Typography
              variant="h4"
              className="myh2"
              id="Licenses"
              color="white"
              mb={3}
            >
              Guided Turkey Hunts!
            </Typography>
            <Typography
              variant="body2"
              color="white"
              mb={2}
              opacity={0.8}
              textAlign={'left'}
            >
              Hunters Are Welcome to Call Their Own Turkeys if Desired All
              Turkey Hunts Have a 2-Day Minimum Requirement Hunts Require a 50%
              Non-Refundable Deposit to Secure Your Spot Any Turkey 'Shot At'
              Counts as a Bird in Your Package
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
            lg={6}
            sx={{
              pl: { xs: 3, lg: 3 },
              pr: { xs: 3, lg: 6 },
              pt: { xs: 6, md: 1, lg: 4 },
              pb: { xs: 6, md: 1, lg: 4 },
            }}
          >
            <Box
              component="img"
              src={TurkeyImage}
              alt="Turkey Hunting Georgia"
              sx={{
                width: { xs: '100%', md: '60%', lg: '50%' },
                height: 'auto',
                borderRadius: '10px',
                display: 'block',
                mx: 'auto',
              }}
            />
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default Turkey;
